import { call, put, takeLatest } from 'redux-saga/effects'
import { fetchUserProfile, logoutUserProfile } from '../../services/api'

import {
  PROFILE_LOAD_REQUESTING, PROFILE_LOAD_ERROR, PROFILE_LOAD_SUCCESS,
  PROFILE_UNLOAD_REQUESTING, PROFILE_UNLOAD_SUCCESS, PROFILE_UNLOAD_ERROR
} from "./constants";

function* requestUserProfile(action) {
  try {
    const profileResponse = yield call(fetchUserProfile);
    yield put({
      type: PROFILE_LOAD_SUCCESS,
      payload: {
        profile: profileResponse.response.profile
      }
    });
  } catch (e) {
    yield put({
      type: PROFILE_LOAD_ERROR,
      errorType: e.errorType,
      message: e.message
    });
  }
}

function* requestUserProfileUnload(action) {
  console.log("Logging out");

  try {
    yield call(logoutUserProfile);
    yield put({
      type: PROFILE_UNLOAD_SUCCESS,
      payload: {}
    });
  } catch (e) {
    yield put({
      type: PROFILE_UNLOAD_ERROR,
      message: e.message
    });
  }
}

export default function* ProfileWatcher() {
  yield takeLatest(PROFILE_LOAD_REQUESTING, requestUserProfile)
  yield takeLatest(PROFILE_UNLOAD_REQUESTING, requestUserProfileUnload)
}